import React from "react";

const ImageSVG = ({ color = "#718EBF", height = "16px", width = "16px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      // style={{ display: "flex" }} 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50065 9.16732C8.42113 9.16732 9.16732 8.42113 9.16732 7.50065C9.16732 6.58018 8.42113 5.83398 7.50065 5.83398C6.58018 5.83398 5.83398 6.58018 5.83398 7.50065C5.83398 8.42113 6.58018 9.16732 7.50065 9.16732Z"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 12.4991L14.9283 9.92743C14.6158 9.61498 14.1919 9.43945 13.75 9.43945C13.3081 9.43945 12.8842 9.61498 12.5717 9.92743L5 17.4991"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ImageSVG;
